<template>
	<div class="app__form__field" :class="{error: error}">
		<div v-if="label" class="app__form__field__label">{{ label }} <span class="app__form__field__label__require" v-if="require">*</span></div>
		<slot />
		<div class="app__form__field__textprepend"><slot name="textprepend"></slot></div>
		<input-error :errors="error" />
	</div>
</template>

<script setup>
import InputError from './Error.vue';

defineProps({
	label: String,
	error: Object,
	require: Boolean,
});
</script>

<script>
export default {
	name: 'FormField',
};
</script>
